import ISO6391 from 'iso-639-1'
import {Button, Link} from '@mui/material'
import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {AttributeModel} from '../model/AttributeModel'
import {useCurrentGuildContext} from '../../util/routing'
import {useTypedSelector} from '../../util/store'
import {CustomTooltip} from '../../genericComponents/customTooltip/CustomTooltip'
import {DateDisplay} from '../../genericComponents/date/dateDisplay'
import {Document, FileStatus} from '../model/AttributeValue'
import {ComplexAttribute} from './ComplexAttribute'
import {IdType} from '../../util/models/IdType'
import { useLazyGetArtifactFileQuery } from '../../item/rtkItemApi'
import { FileViewerDialog } from '../../fileViewer/FileViewerDialog'

export const ArtifactAttribute = ({attribute}: { attribute: AttributeModel }) => {
    const [currentGuildContext] = useCurrentGuildContext()
    const {itemId} = useParams()
    const [currentDocument, setCurrentDocument] = useState('')
    const {itemDocument} = useTypedSelector((state) => state.item)
    const [openDialog, setOpenDialog] = useState(false)

    const [triggerGetFile, {data: retrievedFile, isFetching}] = useLazyGetArtifactFileQuery()

    useEffect(() => {
        if (!itemDocument.isLoading && currentDocument !== '') {
            setCurrentDocument('')
        }
    }, [itemDocument, currentDocument])

    if (!attribute.value.document?.id) return <></>

    const getArtefactDocument = (documentId: IdType) => {
        setCurrentDocument(documentId)
        triggerGetFile({itemId: itemId, guildId: currentGuildContext?.guildId, documentId: documentId})
        setOpenDialog(true)
    }

    const renderDocument = (document: Document) => {
        if (document.externalUrl) return <Button component={Link}
                                                 className="artifact-download"
                                                 href={document.externalUrl}
                                                 target="_blank"
                                                 data-testid="artefact-externalurl-download">{document.externalUrl}</Button>

        if (!document.file || !document.id) return <></>

        return <>
            <Button className="artifact-download" title={document?.name || 'undefined'} id={document.id}
                        disabled={document.file.status !== FileStatus.VALID || currentDocument === document.id}
                        onClick={() => getArtefactDocument(document.id!)}
                        data-testid="artefact-file-preview">
                <span>{document?.name || 'undefined'}</span>
            </Button>
            <FileViewerDialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                title={document?.name || ''}
                file={retrievedFile}
                isFetching={isFetching}
            />
        </>
    }

    const renderPublishedDate = (date: number[]) => {
        if (!date) return <span></span>
        return <div><CustomTooltip title="Published date" arrow>
            <div className="artifact-published-date"><DateDisplay entryDate={date} time={false}/></div>
        </CustomTooltip></div>
    }

    const getLanguages = (document: Document) => {
        return document.languages.map(language => ISO6391.getName(language)).join(', ')
    }

    return <ComplexAttribute attribute={attribute}>
        <div key={attribute.id}
             id={attribute.id}
             className={'artifact-attribute'}
             data-testid="test-details-simple-attribute-value">
            {attribute.value.document && <>
                <div>{renderDocument(attribute.value.document)}</div>
                {renderPublishedDate(attribute.value.document.startOfValidity)}
                {attribute.value.document.languages.length > 0 &&
                    <span>{getLanguages(attribute.value.document)}</span>}
            </>}
        </div>
    </ComplexAttribute>

}